import script from "./Additions.vue?vue&type=script&setup=true&lang=js"
export * from "./Additions.vue?vue&type=script&setup=true&lang=js"

import "./Additions.vue?vue&type=style&index=0&id=27ab042e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ab042e"]])

export default __exports__